import React from 'react'
import { useStoreState } from '../../../models/RootStore';

const DisconnectedResources: React.FC<{ type?: number | null, resources: any[] | null }> = ({
	resources,
	type,
}) => {
	const { eventTypes } = useStoreState((s: any) => s.types);

	const isUnitsDisconnectedAlert = type === eventTypes.unitsDisconnected;

	if (!isUnitsDisconnectedAlert || !resources || resources.length <= 1) {
		return null;
	}

	const disconnectedCount = resources.filter(
		(entry: any | null) => entry && !entry.isConnected
	).length;

	return (
		<span>
			({disconnectedCount}/{resources.length})
		</span>
	);
};

export default DisconnectedResources;